<template>
  <div>
    <voucher-form
            @submit="updateVoucher"
            :post="currentVoucher"
            :loading="loading">
    </voucher-form>
    <voucher-orders
      title="Orders"
    ></voucher-orders>
  </div>
</template>
<script>
  import VoucherForm from './VoucherForm'
  import VoucherService from 'src/services/VoucherService'
  import VoucherOrders from "./VoucherOrders";
  export default {
    name: 'voucher-edit',
    components: {
      VoucherForm,
      VoucherOrders
    },
    data () {
      return {
        loading: false
      }
    },
    methods: {
      async updateVoucher(voucher) {
        try {
          this.loading = true
          await VoucherService.update(voucher.id,voucher)
          this.$router.push('/ecommerce/vouchers')
        } catch (e) {
          console.warn(e)
        }
        this.loading = false
      }
    },

    computed: {
      currentVoucher() {
        return this.$store.state.vouchers.currentVoucher
      }
    },
  }
</script>
<style>
</style>
